import { render, staticRenderFns } from "./Ppb.vue?vue&type=template&id=d10d7944"
import script from "./Ppb.vue?vue&type=script&lang=js"
export * from "./Ppb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports